export const displayNumber = (number, behindComma) => parseFloat(number).toFixed(behindComma != null ? behindComma : 2);

export const precision = a => {
    let e = 1;
    while (Math.round(a * e) / e !== a) e *= 10;
    return Math.log(e) / Math.LN10;
};
